/**
 * Benefits Section
 */

class BenefitsSection {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Section initialization
    console.log('Benefits section initialized');
  }
}

// Initialize section on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefitsSections);
} else {
  initBenefitsSections();
}

function initBenefitsSections() {
  const sections = document.querySelectorAll('[data-section-type="w-benefits"]');
  sections.forEach(section => {
    new BenefitsSection(section);
  });
}

// Shopify theme editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-section-type="w-benefits"]')) {
      new BenefitsSection(event.target.querySelector('[data-section-type="w-benefits"]'));
    }
  });
}
